import { Injectable } from '@angular/core';
import { Response, Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { config } from '../app.config';

@Injectable()
export class ApiService {

  private _client_cd: string;
  private _store_id: string;
  private _menubook_id: string;

  constructor(private _http: Http) {
    this._client_cd = localStorage.getItem("client_cd");
    this._store_id = localStorage.getItem("store_id");
    this._menubook_id = localStorage.getItem("menubook_id");
  }
  public getGmolink() {
    console.log(localStorage.getItem("stgpay"));
    if (localStorage.getItem("stgpay")) {
      return "pt01.mul-pay.jp";
    }
    // return "p01.mul-pay.jp";
    return "pt01.mul-pay.jp";
  }

  public getSingleTableOccupation(table_id): Observable<any> {
    let json_param: any = JSON.stringify({ "store_id": this._store_id, "uiid": `${config.uiid}`, "table_id": table_id });
    return this._http.get(`${config.service}?r=tableOccupations/get_single_table_occupation&client_cd=${this._client_cd}&json=${json_param}`)
      .map((response: Response) => response.json());
  }

  public getGmoMultipayMemberRequest(json: object, memberID, orderID): Observable<any> {
    let json_param = JSON.stringify(json);
    return this._http.get(`${config.service}?r=gmoMultiPayment/createMemberRequest&json=${json_param}&client_cd=${this._client_cd}&store_id=${this._store_id}&MemberID=${memberID}&OrderID=${orderID}`)
      .map((response: Response) => response.json());
  }

  public getPaymentRequest(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    let redirect_url = localStorage.getItem("redirect_url");
    let build_as_takeout = (config.build_as_takeout)
    ? 1 : 0;
    return this._http.get(`${config.service}?r=mobileOrderPayment/request&json=${json_param}&client_cd=${this._client_cd}&store_id=${this._store_id}&build_as_takeout=${build_as_takeout}`)
      .map((response: Response) => response.json());
  }

  public getGmoMultipayRequest(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    return this._http.get(`${config.service}?r=gmoMultiPayment/createRequest&json=${json_param}&client_cd=${this._client_cd}&store_id=${this._store_id}`)
      .map((response: Response) => response.json());
  }

  /**
   * get MobileOrderSetting
   *
   * @returns {Observable<R>}
   */
  public getSettings(): Observable<any> {
    let url_post: any = JSON.stringify({ "store_id": this._store_id, "uiid": `${config.uiid}` });
    return this._http.get(`${config.service}?r=mobileOrderSettings/&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * get ReservedSettings
   *
   * @returns {Observable<R>}
   */
  public getReservedSettings(menubook_id): Observable<any> {
    let url_post: any = JSON.stringify({ "store_id": this._store_id, "uiid": `${config.uiid}`, "menubook_id": `${menubook_id}` });
    return this._http.get(`${config.service}?r=reservedSettings/&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * list all product categories
   *
   * @returns {Observable<R>}
   */
  public getAllProductCategories(): Observable<any> {
    return this._http.get(`${config.service}app/categoryList?did=${config.did}`)
      .map((response: Response) => response.json());
  }

  /**
   * get Store
   *
   * @returns {Observable<R>}
   */
  public getStores(): Observable<any> {
    let url_post: any = JSON.stringify({ "store_id": this._store_id, "uiid": `${config.uiid}` });
    return this._http.get(`${config.service}?r=stores/get&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * get Visitor
   *
   * @param password
   * @returns {Observable<R>}
   */
  public getVisitor(password: string): Observable<any> {
    let url_post: any = JSON.stringify({ "store_id": this._store_id, "uiid": `${config.uiid}` });
    return this._http.get(`${config.service}?r=visitors/get&password=${password}&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * insert visitor
   *
   * @returns {Observable<R>}
   */
  public insertVisitor(receivetime, note, email, sms, notificationType, custom, isTakeoutMethod, guestId, guestDescription, menubook_id): Observable<any> {

    let visitor_id = localStorage.getItem("visitor_id");
    let url_post: any = JSON.stringify({
      "store_id": this._store_id,
      "uiid": `${config.uiid}`,
      "device_token": "STG_ハンディ",
      "version": "2.5.1",
      "age_id": 0,
      "staff_id": 1,
      "custom": (custom) ? custom : "",
      "mobile": 1,
      "mobile_email": (email) ? email.replace(/\+/g, '%2B') : "",
      "mobile_sms": (sms) ? sms : "",
      "mobile_notification_type": (notificationType) ? notificationType : "",
      "mobile_note": (note) ? note : "",
      "mobile_user_receivetime": receivetime,
      "is_takeout": isTakeoutMethod ? 1 : 2,
      "guest_id": (guestId) ? guestId : "",
      "guest_description": (guestDescription) ? guestDescription : "",
      "menubook_id": (menubook_id) ? menubook_id : "",
    });
    return this._http.get(`${config.service}?r=visitors/insert_visitor&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * list all products
   *
   * @param cid
   * @returns {Observable<R>}
   */
  public getAllProductsByCateId(cid: number = 0): Observable<any> {
    return this._http.get(`${config.service}app/productRankingList?did=${config.did}&category_id=${cid}`)
      .map((response: Response) => response.json());
  }

  /**
   * check status services
   *
   * @returns {Observable<R>}
   */
  public checkVisitor(): Observable<any> {
    let visitor_id = localStorage.getItem("visitor_id");
    let payment_type = localStorage.getItem("paymentType");
    let build_as_takeout = (config.build_as_takeout)
    ? 1 : 0;
    let url_post: any = JSON.stringify({ "store_id": this._store_id, "uiid": `${config.uiid}`, "device_token": "STG_ハンディ", "version": "2.5.1", "payment_type": payment_type });
    return this._http.get(`${config.service}?r=visitors/check&visitor_id=${visitor_id}&json=${url_post}&client_cd=${this._client_cd}&build_as_takeout=${build_as_takeout}`)
      .map((response: Response) => response.json());
  }

  /**
   * check reserved status services
   *
   * @returns {Observable<R>}
   */
  public checkReservedVisitor(): Observable<any> {
    let visitor_id = localStorage.getItem("visitor_id");
    let payment_type = localStorage.getItem("paymentType");
    let build_as_takeout = (config.build_as_takeout)
    ? 1 : 0;
    let url_post: any = JSON.stringify({ "store_id": this._store_id, "uiid": `${config.uiid}`, "device_token": "STG_ハンディ", "version": "2.5.1", "payment_type": payment_type });
    return this._http.get(`${config.service}?r=reservedVisitors/check&visitor_id=${visitor_id}&json=${url_post}&client_cd=${this._client_cd}&build_as_takeout=${build_as_takeout}`)
      .map((response: Response) => response.json());
  }

  /**
   * login services
   *
   * @returns {Observable<R>}
   */
  public login(username, password): Observable<any> {
    let url_post: any = JSON.stringify({ "password": password, "userid": username, "uiid": `${config.uiid}`, "device_token": "STG_ハンディ", "version": "2.5.1" });
    return this._http.get(`${config.service}?r=employees/login&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * login log
   *
   * @returns {Observable<R>}
   */
  public login_log(url_login_log: string): Observable<any> {
    return this._http.get(`${config.service}?r=employees/login_log&json=${url_login_log}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * list all ranking
   *
   * @param cid
   * @returns {Observable<R>}
   */
  public getRankingList(ranking_id: number = 1): Observable<any> {
    let url_post: any = JSON.stringify({ "uiid": `${config.uiid}`, "store_id": this._store_id, "ranking_id": ranking_id, "version": "2.5.1" });
    return this._http.get(`${config.service}?r=ranking/ranking_list&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * list all like
   *
   * @param cid
   * @returns {Observable<R>}
   */
  public getFavoriteList(category_id: number = 0): Observable<any> {
    let url_post: any = JSON.stringify({ "uiid": `${config.uiid}`, "store_id": this._store_id, "category_id": category_id, "version": "2.5.1" });
    return this._http.get(`${config.service}?r=ranking/like_list&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  public like(menu_id: number = 0): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    let params: any = JSON.stringify({ "uiid": `${config.uiid}`, "store_id": this._store_id, "version": "2.5.1" });
    return this._http.post(`${config.service}?r=api/likes&json=${params}&client_cd=${this._client_cd}&menu_id=${menu_id}`, 'add=1', options)
      .map((response: Response) => response.json());
  }

  public unlike(menu_id: number = 0): Observable<any> {
    let params: any = JSON.stringify({ "uiid": `${config.uiid}`, "store_id": this._store_id, "version": "2.5.1" });
    return this._http.delete(`${config.service}?r=api/likes&json=${params}&client_cd=${this._client_cd}&menu_id=${menu_id}`)
      .map((response: Response) => response.json());
  }

  public getMenulayouts(inside = false): Observable<any> {
    let visitor_id = localStorage.getItem("visitor_id");
    let menubook_id = localStorage.getItem("menubook_id");
    let reserved = localStorage.getItem("reserved");
    let params: any = JSON.stringify({ "uiid": `${config.uiid}`, "store_id": this._store_id, "version": "2.5.1", "menubook_id": menubook_id, "reserved" : reserved });
    let modname = (inside) ? "inside_mobile" : "outside_mobile";
    return this._http.get(`${config.service}?r=menulayouts/${modname}&json=${params}&visitor_id=${visitor_id}&client_cd=${this._client_cd}&menubook_id=${menubook_id}`)
      .map((response: Response) => response.json());
  }

  public getMenuList(loc): Observable<any> {
    return this._http.get(`${config.service}?cache=1&r=menus/sync&loc=${loc}&sql=SELECT menus.*, menu_likes.likes FROM menus LEFT JOIN menu_likes ON menu_likes.menu_id = menus.menu_id WHERE store_id = :store_id order by sort_order&model=Menus&client_cd=${this._client_cd}&json={"store_id":"${this._store_id}","client_code":"${this._client_cd}","uiid":"${config.uiid}"}`)
      .map((response: Response) => response.json());
  }

  public getMenuGroups(): Observable<any> {
    return this._http.get(`${config.service}?cache=1&r=sync/select&model=MenuGroups&sql=SELECT * FROM menu_groups WHERE store_id = :store_id&client_cd=${this._client_cd}&json={"store_id":${this._store_id},"client_code":"${this._client_cd}","uiid":"${config.uiid}"}`)
      .map((response: Response) => response.json());
  }

  public deferredOrder(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this._http.post(`${config.service}?r=orders/insert_deferred_orders&instore_menubook_id=${this._menubook_id}&client_cd=${this._client_cd}&json=${json_param}`, "json=" + json_param, options)
      .map((response: Response) => response.json());
    // return this._http.post(`${config.service}?r=orders/insert_deferred_orders&instore_menubook_id=${this._menubook_id}&client_cd=${this._client_cd}`, "json="+json_param, options)
    //   .map((response: Response) => response.json());
  }

  public order(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this._http.post(`${config.service}?r=orders/insert_orders&instore_menubook_id=${this._menubook_id}&client_cd=${this._client_cd}`, "json=" + json_param, options)
      .map((response: Response) => response.json());
  }

  public commitOrder(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    return this._http.get(`${config.service}?r=orders/commit_order&json=${json_param}&client_cd=${this._client_cd}&from=mobile`)
      .map((response: Response) => response.json());
  }

  public getLastOrder(json: object, loc): Observable<any> {
    let json_param = JSON.stringify(json);
    return this._http.get(`${config.service}?loc=${loc}&r=orders/moget&json=${json_param}&client_cd=${this._client_cd}&last=1`)
      .map((response: Response) => response.json());
  }

  public getLastReservedOrder(json: object, loc): Observable<any> {
    let json_param = JSON.stringify(json);
    return this._http.get(`${config.service}?loc=${loc}&r=reservedOrders/moget&json=${json_param}&client_cd=${this._client_cd}&last=1`)
      .map((response: Response) => response.json());
  }

  public getLastOrderWithDeleted(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    return this._http.get(`${config.service}?r=orders/moget&json=${json_param}&client_cd=${this._client_cd}&last=1&with_deleted=1`)
      .map((response: Response) => response.json());
  }

  public getLastReservedOrderWithDeleted(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    return this._http.get(`${config.service}?r=reservedOrders/moget&json=${json_param}&client_cd=${this._client_cd}&last=1&with_deleted=1`)
      .map((response: Response) => response.json());
  }

  /**
   * qrcode login services
   *
   * @returns {Observable<R>}
   */
  public qrcode_login(token: string, client_cd: string): Observable<any> {
    let url_post: any = JSON.stringify({ "token": token, "uiid": `${config.uiid}`, "device_token": "STG_ハンディ", "version": "2.5.1" });
    return this._http.get(`${config.service}?r=employees/check_token&json=${url_post}&client_cd=${client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * login log
   *
   * @returns {Observable<R>}
   */
  public qrcode_login_log(url_login_log: string): Observable<any> {
    return this._http.get(`${url_login_log}`)
      .map((response: Response) => response.json());
  }

  /**
   * sns login services
   *
   * @returns {Observable<R>}
   */
  public sns_login(visitor_id, store_id, client_cd, password): Observable<any> {
    let url_post: any = JSON.stringify({ "visitor_id": visitor_id, "store_id": store_id, "password": password, "uiid": `${config.uiid}`, "device_token": "STG_ハンディ", "version": "2.5.1" });
    return this._http.get(`${config.service}?r=employees/login_sns&json=${url_post}&client_cd=${client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * get store configurations
   *
   * @returns {Observable<R>}
   */
  public getConfigs(params: string[]): Observable<any> {
    let json: any = JSON.stringify({ "store_id": this._store_id, "uiid": config.uiid, "device_token": "STG_ハンディ", "version": "2.5.1", "params": params });
    return this._http.get(`${config.service}?r=configurations/gets&json=${json}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }

  /**
   * send message
   *
   * @returns {Observable<R>}
   */
  public sendMessage(store_id, visitor_id, action): Observable<any> {
    let json: any = JSON.stringify({ "uiid": config.uiid, "visitor_id": visitor_id, "action": action});
    return this._http.get(`${config.service}?r=sendmail/send&client_cd=${this._client_cd}&store_id=${store_id}&json=${json}`)
      .map((response: Response) => response.json());
  }

  /**
   * send message
   *
   * @returns {Observable<R>}
   */
  public sendReservedMessage(store_id, visitor_id, action): Observable<any> {
    let json: any = JSON.stringify({ "uiid": config.uiid, "visitor_id": visitor_id, "action": action});
    return this._http.get(`${config.service}?r=sendmail/sendReserved&client_cd=${this._client_cd}&store_id=${store_id}&json=${json}`)
  }

  public reservedOrder(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let options = new RequestOptions({ headers: headers });
    return this._http.post(`${config.service}?r=reservedOrders/insert_orders&instore_menubook_id=${this._menubook_id}&client_cd=${this._client_cd}`, "json=" + json_param, options)
      .map((response: Response) => response.json());
  }

  public insertReservedVisitor(receivetime, note, email, sms, notificationType, custom, isTakeoutMethod, guestId, guestName, guestDescription, reserved_settings): Observable<any> {
    let url_post: any = JSON.stringify({
      "store_id": this._store_id,
      "uiid": `${config.uiid}`,
      "device_token": "STG_ハンディ",
      "version": "2.5.1",
      "age_id": 0,
      "staff_id": 1,
      "custom": (custom) ? custom : "",
      "mobile": 1,
      "mobile_email": (email) ? email.replace(/\+/g, '%2B') : "",
      "mobile_sms": (sms) ? sms : "",
      "mobile_notification_type": (notificationType) ? notificationType : "",
      "mobile_note": (note) ? note : "",
      "mobile_user_receivetime": receivetime,
      "is_takeout": isTakeoutMethod ? 1 : 2,
      "guest_id": (guestId) ? guestId : "",
      "guest_name": (guestName) ? guestName : "",
      "guest_description": (guestDescription) ? guestDescription : "",
      "menubook_id": reserved_settings.menubook_id,
      "reserved_setting_id": reserved_settings.reserved_setting_id
    });
    return this._http.get(`${config.service}?r=reservedVisitors/insert_visitor&json=${url_post}&client_cd=${this._client_cd}`)
      .map((response: Response) => response.json());
  }
  public getReservedPaymentRequest(json: object): Observable<any> {
    let json_param = JSON.stringify(json);
    let redirect_url = localStorage.getItem("redirect_url");
    let build_as_takeout = (config.build_as_takeout)
    ? 1 : 0;
    return this._http.get(`${config.service}?r=mobileOrderPayment/reservedRequest&json=${json_param}&client_cd=${this._client_cd}&store_id=${this._store_id}&build_as_takeout=${build_as_takeout}`)
      .map((response: Response) => response.json());
  }

  public getReservedHistory(email, menuIds): Observable<any> {
    let json: any = JSON.stringify({
      "uiid":    config.uiid,
      "email":   email,
      "menuIds": menuIds,
    });
    return this._http.get(`${config.service}?r=reservedOrders/getReservedHistory&json=${json}&client_cd=${this._client_cd}&store_id=${this._store_id}`)
      .map((response: Response) => response.json());
  }
  /**
   * resend mail
   *
   * @returns {Observable<R>}
   */
  public resendMail(json: object) : Observable<any> {
    let json_param = JSON.stringify(json);
    // let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    // let options = new RequestOptions({ headers: headers });
    return this._http.get(`${config.service}?r=visitors/resendMail&client_cd=${this._client_cd}&json=${json_param}`)
      .map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts